import * as Three from 'three';

export const parseWallChains = (parent) => {
  const walls = {};

  if (!parent || !parent.content || !(parent.content instanceof Array)) {
    return;
  }

  const hash = (x, y) => {
    return `${parseInt(x, 10)}:${parseInt(y, 10)}`;
  };

  parent.content.forEach((branch) => {
    const {
      type,
      positionX,
      positionZ,
      endX,
      endZ,
    } = branch;

    if (type !== 'wall') {
      return;
    }

    branch.wallChainId = null;
    branch.junction = false;

    const a = hash(positionX, positionZ);
    const b = hash(endX, endZ);

    if (!walls[a]) {
      walls[a] = [];
    }

    if (!walls[b]) {
      walls[b] = [];
    }
    
    walls[a].push(branch);
    walls[b].push(branch);
  });

  const lines = [];
  const junctions = [];

  Object.keys(walls).map((coords) => {
    const parts = walls[coords];
    const junctionPaths = [];

    if (!(parts.length === 1 || parts.length >= 3)) {
      const wallA = parts[0];
      const wallB = parts[1];
      const angle = new Three.Vector3(wallA.positionX - wallA.endX, 0, wallA.positionZ - wallA.endZ).angleTo(
        new Three.Vector3(wallB.positionX - wallB.endX, 0, wallB.positionZ - wallB.endZ)
      );

      if ((Math.abs(angle) % Math.PI) === 0) {
        return;
      } else {
        wallA.junction = true;
        wallB.junction = true;
        if (wallA.positionX === wallB.positionX && wallA.positionZ === wallB.positionZ) {
          junctions.push({ positionX: wallA.positionX, positionZ: wallA.positionZ, wallA, wallB });
        } else if (wallA.endX === wallB.positionX && wallA.endZ === wallB.positionZ) {
          junctions.push({ positionX: wallA.endX, positionZ: wallA.endZ, wallA, wallB });
        } else if (wallA.endX === wallB.endX && wallA.endZ === wallB.endZ) {
          junctions.push({ positionX: wallA.endX, positionZ: wallA.endZ, wallA, wallB });
        } else if (wallA.positionX === wallB.endX && wallA.positionZ === wallB.endZ) {
          junctions.push({ positionX: wallB.endX, positionZ: wallB.endZ, wallA, wallB });
        }
      }
    }

    const checkNext = (from, currentWall) => {
      const { positionX, positionZ, endX, endZ } = currentWall;
      const start = hash(positionX, positionZ);
      const end = hash(endX, endZ);

      let total = [];

      if (end !== from && walls[end].length <= 2) {
        const nextWall = walls[end].filter(i => i !== currentWall)[0];

        if (nextWall) {
          const angle = new Three.Vector3(nextWall.positionX - nextWall.endX, 0, nextWall.positionZ - nextWall.endZ).angleTo(
            new Three.Vector3(currentWall.positionX - currentWall.endX, 0, currentWall.positionZ - currentWall.endZ)
          );

          if ((Math.abs(angle) % Math.PI) === 0) {
            total = [ nextWall, ...checkNext(end, nextWall) ];
          }
        }
      }

      if (start !== from && walls[start].length <= 2) {
        const nextWall = walls[start].filter(i => i !== currentWall)[0];

        if (nextWall) {
          const angle = new Three.Vector3(nextWall.positionX - nextWall.endX, 0, nextWall.positionZ - nextWall.endZ).angleTo(
            new Three.Vector3(currentWall.positionX - currentWall.endX, 0, currentWall.positionZ - currentWall.endZ)
          );

          if ((Math.abs(angle) % Math.PI) === 0) {
            total = [ nextWall, ...checkNext(start, nextWall) ];
          }
        }
      }

      return [ currentWall, ...total ];
    };

    parts.forEach(wall => {
      junctionPaths.push(checkNext(coords, wall));
    });

    junctionPaths.forEach((chain) => {
      const start = chain[0];
      const end = chain[chain.length - 1];

      let chainNameA;
      let chainNameB;

      if (start !== end) {
        chainNameA = `${hash(start.positionX, start.positionZ)}->${hash(end.positionX, end.positionZ)}`;
        chainNameB = `${hash(end.positionX, end.positionZ)}->${hash(start.positionX, start.positionZ)}`;
      } else {
        chainNameA = `${hash(start.positionX, start.positionZ)}->${hash(start.endX, start.endZ)}`;
        chainNameB = `${hash(start.endX, start.endZ)}->${hash(start.positionX, start.positionZ)}`;
      }

      if (!lines[chainNameA] && !lines[chainNameB]) {
        lines[chainNameA] = chain;

        chain.forEach(branch => branch.wallChainId = chainNameA);
      }
    });
  });

  return { walls, lines, junctions };
};
